import { SqlParameterType } from 'features/maps/types'
import { isInIframe } from '../../app/utils/embedding'
import { WidgetType } from './types'

export type ParentAppMapLoadedEventData = {
  title: string
  widgets: {
    id: string
    type: WidgetType
    title: string
  }[]
  sqlParameters: {
    name: string
    type: SqlParameterType
  }[]
}

export type ParentAppMapLoadedEvent = {
  type: 'cartoMapLoaded'
  data: ParentAppMapLoadedEventData
}

export type ParentAppMapUpdatedEventData = {
  // basic map state
  lat: number
  long: number
  zoom: number
  bearing: number
  pitch: number
  search?: string
  layers: number[]
  mask?: string
  widgetFilters: {
    id: string
    /**
     * Current filter value
     *
     *  * category and pie widget, will emit string[]
     *  * range and histogram will emit number[][], as array of ranges ([min,max])
     */
    value: string[] | number[][]
  }[]
  sqlParametersValues: {
    name: string
    value: string | number | string[]
  }[]
}
export type ParentAppMapUpdatedEvent = {
  type: 'cartoMapUpdated'
  data: ParentAppMapUpdatedEventData
}

export type ParentAppAccessTokenRequestEvent = {
  type: 'cartoAccessTokenRequest'
}

type ParentAppEvent = ParentAppMapLoadedEvent | ParentAppMapUpdatedEvent | ParentAppAccessTokenRequestEvent

export function sendParentAppEvent(message: ParentAppEvent) {
  if (isInIframe && window.parent) {
    window.parent.postMessage(message, '*')
  }
}
